export const ITEM_SECTION_HEADER_ROW_HEIGHT = 40
export const MAX_RECENT_SEARCH_RESULTS = 4
